import React, { useRef, useEffect, useState, forwardRef } from 'react';
import {LABELS_TYPE, SHIPPINGS_COUNT_CALENDAR_TYPE} from '../../../constants/columnTypes';
import FacetField from '../../FilterComponents';

const HeaderCellComponent = forwardRef(
    ({ row, index, setFilter, width, setSort, filters = {}, sort = {}, gridName }, ref) => {
        /* const cellRef = useRef(null);
    let [position, setPosition] = useState(null);

    useEffect(() => {
        setPosition(cellRef.current.offsetLeft);
    }, []);
*/

    if (row.type === LABELS_TYPE || row.type === SHIPPINGS_COUNT_CALENDAR_TYPE) {
        width = 600;
    }

        return (
            <th
                className={
                    row.isFixedPosition ? 'no-scroll table-header-cell' : 'table-header-cell'
                }
                ref={ref}
                style={
                    row.isFixedPosition
                        ? {
                              left: (index * 150) + 50,
                              maxWidth: '150px',
                              minWidth: '150px',
                          }
                        : width
                        ? {
                              maxWidth: `${width}px`,
                              minWidth: `${width}px`,
                          }
                        : { maxWidth: '600px' }
                }
            >
                <FacetField
                    key={'facet' + row.name}
                    notWrapHeader
                    index={index}
                    name={row.name}
                    gridName={gridName}
                    displayName={row.displayName}
                    displayNameKey={row.displayNameKey}
                    sort={sort && sort.name === row.name ? sort.desc : null}
                    setSort={setSort}
                    type={row.filterType}
                    value={
                        filters.filter && filters.filter.filter && filters.filter.filter[row.name]
                    }
                    filters={filters}
                    setFilter={setFilter}
                    source={row.source}
                    noSort={row.isSortDisabled}
                    notSortAndFilter={row.isSortDisabled}
                />
            </th>
        );
    },
);

export default React.memo(HeaderCellComponent);
